import { objectOf } from "@altostra/type-validations";
import { boolean } from "@altostra/type-validations/lib/primitives";

export const engagementAppGroupIdFeatureFlagsRolloutIdExperimentUsageResult = objectOf({
  is_used_in_experiment: boolean,
});
